export default "__VITE_ASSET__C7oVG7JB__"